import { Grid } from '@mui/material';
import React from 'react';
import './SideMenuItem.scss';

export class SideMenuItemProps {
    iconName?: string;
    label?: string;
    onClick?: any
}

function SideMenuItem(props: SideMenuItemProps) {
    return (
        <div onClick={props.onClick} className='hover'>
            <Grid container className='side-menu-container'>

                <Grid item xs={3} className='flex-end-center'><img className='side-menu-icon' src={process.env.PUBLIC_URL + '/icons/' + props.iconName} /></Grid>
                <Grid item xs={9} className='flex-start-center pl-2'>
                    <div className='side-menu-title'>
                        {props.label}
                    </div>
                </Grid>
            </Grid>
        </div>
    );
}

export default SideMenuItem;